import React, { useState } from "react";
import { Modal, Form } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import JoditEditor, { Jodit } from "jodit-react";
import { Button, CircularProgress } from "@mui/material";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { AddComment } from "@mui/icons-material";
import Cookies from "universal-cookie";

// Configuración personalizada del editor
Jodit.lang.es = {
  ...Jodit.lang.es,
  "The pasted content looks like HTML. Keep as HTML?":
    "El contenido parece ser HTML. ¿Deseas mantenerlo como está?",
};
const editorConfig = {
  readonly: false,
  language: "es",
  toolbarAdaptive: false,
  toolbarSticky: false,
  showCharsCounter: true,
  showWordsCounter: true,
  showXPathInStatusbar: false,

  iframe: false,
  useSearch: false,
  uploader: { insertImageAsBase64URI: true },

  askBeforePasteFromWord: false,
  askBeforePasteHTML: false, // 🔧 evita el mensaje nativo de "¿Mantener como HTML?"
  defaultActionOnPaste: "insert_as_html", // mantiene el HTML original
};

// eslint-disable-next-line react/prop-types
const GestionSolicitante = ({ id }) => {
  const cookie = new Cookies();
  const formatDateTimeColombia = () => {
    const now = new Date();
    const colombiaTime = new Intl.DateTimeFormat("sv-SE", {
      timeZone: "America/Bogota",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(now);

    return colombiaTime.replace(" ", "T");
  };

  const [formData, setFormData] = useState({
    idSolicitud: id,
    descripcion: "",
    fechaCreacion: formatDateTimeColombia(),
    idUsuario: cookie.get("id"),
    estado: "1",
  });

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleEditorChange = (value) => {
    setFormData((prev) => ({ ...prev, descripcion: value }));
  };

  const handleSubmit = async () => {
    if (!formData.descripcion.trim()) {
      Swal.fire("Error", "La descripción no puede estar vacía", "error");
      return;
    }

    try {
      setLoading(true);

      if (formData.estado) {
        await handleActualizarSolicitud();
      }

      await axios.post("https://contratosback.azurewebsites.net/api/v1/CreaGestion", formData, {
        headers: { "Content-Type": "application/json" },
      });

      Swal.fire({
        title: "Éxito",
        text: "Gestión creada correctamente",
        icon: "success",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });

      handleClose();
    } catch (error) {
      console.error("Error al crear la gestión", error.response || error.message);
      Swal.fire("Error", "Hubo un problema al crear la gestión", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleActualizarSolicitud = async () => {
    try {
      await axios.patch(
        `https://contratosback.azurewebsites.net/api/v1/ActualizaSolicitudJuridica/${id}`,
        { idSolicitud: id, idEstado: formData.estado, informacionAdicional: "Gestion" },
        { headers: { "Content-Type": "application/json" } }
      );
    } catch (error) {
      console.error("Error al actualizar la solicitud", error.response || error.message);
      Swal.fire("Error", "No se pudo actualizar la solicitud", "error");
    }
  };

  return (
    <div>
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="tooltip-crear-caso">Nueva Gestión</Tooltip>}
      >
        <Button variant="contained" color="primary" onClick={handleOpen}>
          <AddComment style={{ color: "white", fontSize: "1.2rem" }} />
        </Button>
      </OverlayTrigger>

      <Modal title="Crear Gestión" open={open} onCancel={handleClose} footer={null} width={1100}>
        <Form layout="vertical" onFinish={handleSubmit}>
          <Form.Item label="Descripción">
            <JoditEditor
              config={editorConfig}
              value={formData.descripcion || ""}
              onBlur={(newContent) => setFormData((prev) => ({ ...prev, descripcion: newContent }))}
              onChange={() => {}} // Previene doble escritura durante typing
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="submit"
              style={{ marginLeft: 10, border: "2px solid blue", color: "blue" }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} style={{ color: "blue" }} /> : "Crear"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default GestionSolicitante;
